import { useState } from 'react';

export const useToggle = (initial: boolean = false) => {
  const [isToggle, setToggle] = useState(initial);
  const toggle = () => setToggle(prevState => !prevState);
  return [isToggle, toggle, setToggle] as const;
};
